import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavbarBrand,
  NavbarToggler,
  Row,
  UncontrolledCollapse,
} from 'reactstrap';
import { getSettings, insertSettings } from '../../redux/actions/settings';

const initialState = {
  isat_uri: '',
  mail_server: '',
  mail_port: '',
  mail_use_tls: '',
  mail_username: '',
  mail_password: '',
  mail_default_sender: '',
  ldap_server: '',
  ldap_bind_username: '',
  ldap_bind_password: '',
  ldap_base: '',
  ldap_name_attribute: '',
  ldap_user_filter: '',
};

const Settings = () => {
  const dispatch = useDispatch();
  const [startUp, setStartUp] = useState(true);
  const { settings, env } = useSelector((state) => state.settings);
  const [environment, setEnvironment] = useState(env);
  const [state, setState] = useState(settings || initialState);
  
  const ldapFields = [
    { name: 'ldap_server', label: 'LDAP Server' },
    { name: 'ldap_bind_username', label: 'LDAP Bind DN' },
    { name: 'ldap_bind_password', label: 'LDAP Bind Password'},
    { name: 'ldap_base', label: 'LDAP Base' },
    { name: 'ldap_user_filter', label: 'LDAP User Filter' },
    { name: 'ldap_name_attribute', label: 'LDAP Name Attribute' },
  ];

  const visibleLdapFields = ldapFields.filter((field) => state?.[field.name]);
  const ldapSettingsVisible = visibleLdapFields.length > 0;

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  useEffect(() => {
    setState(settings);
    setEnvironment(env);
  }, [settings, env]);

  const handleChange = (event) => {
    let { name, value } = event.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const fieldsToSubmit = { ...state };
    for (const key in fieldsToSubmit) {
      if (environment && environment[key] !== undefined) {
        delete fieldsToSubmit[key];
      }
    }
    dispatch(insertSettings(fieldsToSubmit));
    dispatch(getSettings());
  };

  return (
    <Container fluid='md'>
      <CardTitle tag='h1' className='mb-0'>
        <h1>Settings</h1>
      </CardTitle>
      <br />
      <Row>
        <Col className='icon-col'>
          <NavbarToggler id='SettingsToggler' className='mr-2'>
            <FontAwesomeIcon icon={faBars} />
          </NavbarToggler>
        </Col>
        <Col>
          <NavbarBrand className='mr-auto logs-table-name'>
            Admin Settings
          </NavbarBrand>
        </Col>
      </Row>
      <UncontrolledCollapse toggler='#SettingsToggler' defaultOpen>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for='isat_uri' className='mb-2 mt-2'>
                  ISAT URI
                </Label>
                <Input
                  id='isat_uri'
                  name='isat_uri'
                  value={state.isat_uri ?? ''}
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
                <Label for='mail_server' className='mb-2 mt-2'>
                  Mail Server
                </Label>
                <Input
                  id='mail_server'
                  name='mail_server'
                  value={state.mail_server ?? ''}
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
                <Label for='mail_port' className='mb-2 mt-2'>
                  Mail Port
                </Label>
                <Input
                  id='mail_port'
                  name='mail_port'
                  value={state.mail_port ?? ''}
                  type='number'
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
                <Label for='mail_use_tls' className='mb-2 mt-2'>
                  Mail Use TLS
                </Label>
                <Input
                  id='mail_use_tls'
                  name='mail_use_tls'
                  value={state.mail_use_tls ?? ''}
                  type='select'
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                >
                  <option value='' disabled hidden>
                    Select one
                  </option>
                  <option>True</option>
                  <option>False</option>
                </Input>
                <Label for='mail_username' className='mb-2 mt-2'>
                  Mail Username
                </Label>
                <Input
                  id='mail_username'
                  name='mail_username'
                  value={state.mail_username ?? ''}
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
                <Label for='mail_password' className='mb-2 mt-2'>
                  Mail Password
                </Label>
                <Input
                  id='mail_password'
                  name='mail_password'
                  value={state.mail_password ?? ''}
                  type='password'
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
                <Label for='mail_default_sender' className='mb-2 mt-2'>
                  Mail Default Sender
                </Label>
                <Input
                  id='mail_default_sender'
                  name='mail_default_sender'
                  value={state.mail_default_sender ?? ''}
                  onChange={handleChange}
                  className='mb-2 mt-2'
                  title={
                    environment
                      ? 'This field cannot be edited as it is an environment parameter'
                      : ''
                  }
                  disabled={environment}
                />
              </FormGroup>
            </Form>
            {!environment && (
              <Button
                className='btn-add'
                type='submit'
                color='success'
                outline
                style={{
                  display: 'block',
                  marginLeft: 0,
                  marginRight: 'auto',
                  marginTop: '1rem',
                  marginBottom: 0,
                  width: '10%',
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            )}
          </Col>
        </Row>
      </UncontrolledCollapse>
      {ldapSettingsVisible && (
        <>
          <Row>
            <Col className='icon-col'>
              <NavbarToggler id='LDAPToggler' className='mr-2'>
                <FontAwesomeIcon icon={faBars} />
              </NavbarToggler>
            </Col>
            <Col>
              <NavbarBrand className='mr-auto logs-table-name'>
                LDAP Settings
              </NavbarBrand>
            </Col>
          </Row>
          <UncontrolledCollapse toggler='#LDAPToggler' defaultOpen>
            <Row>
              <Col>
                {visibleLdapFields.map(({ name, label, type }) => (
                  <div key={name}>
                    <Label for={name} className='mb-2 mt-2'>
                      {label}
                    </Label>
                    <Input
                      id={name}
                      name={name}
                      type='text'
                      value={state[name] ?? ''}
                      onChange={handleChange}
                      className='mb-2 mt-2'
                      title={
                        environment
                          ? 'This field cannot be edited as it is an environment parameter'
                          : ''
                      }
                      disabled={environment}
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </UncontrolledCollapse>
        </>
      )}
    </Container>
  );
};

export default Settings;
